<template>

  <v-dialog v-model="dialog" scrollable fullscreen style="z-index: 999999900">
    <v-card>
      <v-card-title class="title bluetext">
        Aus der Mediathek hinzufügen
        <v-spacer></v-spacer>
        <v-btn icon dark @click="dialog = false" class="ma-4" color="primary">
          <v-icon>close</v-icon>
        </v-btn>

      </v-card-title>

      <v-card color="transparent" flat>
        <v-card-text class="font-weight-light text-xs-left title bluetext">
        </v-card-text>
      </v-card>
      <div v-if="itemToZoom != null" style="z-index:100000000; background-color: white;position: absolute; left:0px;top:0px;right:0px;bottom: 0px;">
         <v-row>
           <v-spacer>

           </v-spacer>
           <v-btn icon dark @click="itemToZoom = null" class="mr-4" color="primary">
             <v-icon>close</v-icon>
           </v-btn>

         </v-row>
        <v-row align="center" justify="center">
          <v-card
              :color="hover ? 'lightgrey' : undefined"
              max-width="90%"
              width="90%"
              class="ma-2"
              flat
          >
            <center><video :src="getVideoUrl(itemToZoom)" ref="player" autoplay :style="'max-width: 90%;padding:0px;max-height: ' + mh + 'px;height: 90%;margin: 0px;'"></video>
            <div style="width: 350px;height:22px; background-color: lightgray" :title="itemToZoom.localFileName">
              <span style="width:200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: bold" class="ml-2">{{itemToZoom.title}}</span>
              <span style="float: right"> {{itemToZoom.duration}} Sek. <v-icon small class="pa-0 nt-0 mr-2">mdi-timelapse</v-icon></span>
            </div>
            </center>
          </v-card>
        </v-row>
      </div>
      <v-card-text>
        <v-col cols="12" v-if="false">
          <v-text-field
                  color="cyan darken-3"
                  clearable
                  v-model="url"
                  label="Text suche"
                  outlined
          ></v-text-field>
        </v-col>
        <v-col cols="12">
         <v-chip  v-for="category in categories" v-bind:key="category" :color="getChipColor(category)" @click="onClickChip(category)">
           {{category}}
         </v-chip>
          <v-menu v-model="menu" offset-y :close-on-content-click="true" :open-on-hover="true">
            <template v-slot:activator="{ on }">
              <span v-on="on" class="font-weight-bold"><v-icon color="primary">sort</v-icon>{{ sortName }}</span>
            </template>
            <v-list>
              <v-list-item @click="sortyByDate">
                Neueste
              </v-list-item>
              <v-list-item @click="sortyByName">
                Name
              </v-list-item>
            </v-list>
          </v-menu>
        </v-col>
        <v-col cols="12">
          <v-row justify="start">
            <div v-for="item in filteredItems" v-bind:key="item.id + item.isHovering">
              <v-hover
                  v-slot:default="{ hover }"
                  open-delay="200"
              >
                <v-card
                    :color="hover ? 'lightgrey' : undefined"
                    max-width="350"
                    width="350"
                    class="ma-2"
                    flat
                    @click="addMedia(item)"
                >
                  <v-system-bar window light>
                    <v-icon class="pl-2" color="cyan darken-3" @click.stop="itemToZoom = item" small>zoom_out_map</v-icon>
                  </v-system-bar>
                  <center v-if="hover" ><video :src="getVideoUrl(item)" ref="player" autoplay style="max-width: 350px;padding:0px;max-height: 190px;height: 190px;margin: 0px;"></video></center>
                  <v-img v-else :src="tableUtils.getImage(item)" :lazy-src="tableUtils.getImageThumbUrl(item)" contain alt="Thumbnail" max-height="197"></v-img>
                  <div style="width: 350px;height:22px; background-color: lightgray" :title="item.localFileName">
                    <span style="width:200px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;font-weight: bold" class="ml-2">{{item.title}}</span>
                    <span style="float: right"> {{item.duration}} Sek. <v-icon small class="pa-0 nt-0 mr-2">mdi-timelapse</v-icon></span>
                  </div>
                </v-card>
              </v-hover>
            </div>
          </v-row>
        </v-col>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="doCancel()" color="red darken-4" small dark outlined
               class="radiusBtn text-none">Abbrechen
        </v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  //import Vue from 'vue'

  import Vue from "vue";
  import _ from "lodash";

  export default {
    name: 'DialogAddMediathekItem',
    components: {},
    methods: {
      /**
       * newName, title, type
       * @param cardConfig
       */
      doCancel: function () {
        this.dialog = false
        this.$emit('cancel', null)
      },
      addMedia: function (item) {
        console.log('add media', item)
        this.dialog = false
        this.$emit('addMedia', {
          item: item
        })
      },
      onGetItems: function (data) {
        console.log('onGetItems', data)
        this.items = data
        this.categories = ['Alle']
        const cmp = this
        _.each(this.items, function (item) {
            let splitted = item.name.split('_')
            if (splitted.length < 1) {
              splitted = [item]
            }
            if (cmp.categories.indexOf(splitted[0]) < 0) {
              cmp.categories.push(splitted[0])
            }
            item.category = splitted[0]
            item.title = item.name
            item.isHovering = false
            if (splitted.length > 0) {
              item.title = splitted[1]
            }
        })
        this.sortyByDate()
      },
      onGetData: function (data) {
        console.log('playlist', data)
        this.playlist = data
        Vue.prototype.$api.loadPlayListItems(this.guid, this.onGetItems)
      },
      open: function (currentDevice) {
        if (currentDevice && currentDevice.orientation === 'vertical') {
          this.guid = 'GlobalMediathekV' // GlobalMediathekV
        } else {
          this.guid = 'GlobalMediathekH'
        }
        Vue.prototype.$api.loadPlayList(this.guid, this.onGetData)
        this.mh = window.innerHeight - 200
        this.itemToZoom = null
        this.dialog = true
      },
      getVideoUrl: function(item) {
        return Vue.prototype.$api.getVideoUrl(item)
      },
      getChipColor: function (chip) {
        return chip === this.selectedCat ? 'primary' : 'lightgrey'
      },
      onClickChip: function (chip) {
        if (chip === this.selectedCat) {
          this.selectedCat = null
          return
        }
        this.selectedCat = chip
      },
      sortyByDate: function () {
        this.sortName = 'Neueste'
        this.items = _.orderBy(this.items,"created", 'desc')
      },
      sortyByName: function () {
        this.sortName = 'Name'
        this.items = _.sortBy(this.items,"title")
      },
    },
    data () {
      return {
        mh: 190,
        menu: false,
        sortName: 'Name',
        itemToZoom: null,
        isHovering: false,
        tableUtils: require('./../../tables/TableUtils').default,
        playlist: [],
        items: [],
        categories: ['Alle'],
        selectedCat: 'Alle',
        url: 'https://www.',
        title: 'Login nicht erfolgreich',
        description: 'Wir konnten die Kombination aus Username und Passwort nicht validieren',
        dialog: false
      }
    },
    computed: {
      filteredItems() {
        const cmp = this
        return cmp.items.filter(item => {
          if (cmp.selectedCat === 'Alle') return true
          if (item.category === cmp.selectedCat) {
            return true
          }
          return false
        })
      }
    },
    mounted () {
    }
  }
</script>

<style scoped>

</style>
